import SearchFilterInput from "../../form-fields/search-filter-input";
import SimpleButton from "../../buttons/Simple-button";
import H2 from "../../typography/H2";
import "./top-listing-headers.css";
import SingleDropdown from "../../singleDropdown/SingleDropdown";
import Chevren_downIcon from "../../../assets/svgs/Chevren_down";

type FeedbackHeaderFilterOption = {
  title: string;
  value: string;
  count: number;
};

interface FeedbackTopHeaderProps {
  className?: string;
  PageHeading?: string;
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  activeFilter: string;
  setActiveFilter: (filter: string) => void;
  onAddClick?: () => void;
  filterOptions?: FeedbackHeaderFilterOption[];
}

export default function FeedbackTopHeader({
  className = "",
  PageHeading = "Feedback",
  searchTerm,
  setSearchTerm,
  activeFilter,
  setActiveFilter,
  onAddClick,
  filterOptions = [],
}: FeedbackTopHeaderProps) {
  const activeFilterOption = filterOptions.find(opt => opt.value === activeFilter);
  const triggerText = activeFilterOption ? `${activeFilterOption.title} (${activeFilterOption.count})` : "All";

  return (
    <div className={`top-listing-headers feedback-header ${className}`}>
      <div className="top-listing-header-main">
        <div className="top-listing-header-left">
          <H2 text={PageHeading} />
          {onAddClick && (
            <div className="top-listing-header-button-mobile">
              <SimpleButton label="Add Feedback" onClick={onAddClick} />
            </div>
          )}
        </div>
        <div className="top-listing-header-right">
          <div className="search-sort-container" style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
            <SearchFilterInput
              placeholder="Search feedback..."
              searchTerm={searchTerm}
              handleSearch={(e) => setSearchTerm(e.target.value)}
            />
            <div className="filters-mobile">
              <SingleDropdown
                key={triggerText}
                triggerText={triggerText}
                triggerIcon={<Chevren_downIcon width={"18"} height={"18"} />}
                triggerIconPosition="right"
                menuItems={filterOptions.map((option: any) => ({
                  label: `${option.title} (${option.count})`,
                  action: () => setActiveFilter(option.value),
                }))}
              />
            </div>
          </div>
          {onAddClick && (
            <div className="top-listing-header-button-desktop">
              <SimpleButton label="Add Feedback" onClick={onAddClick} />
            </div>
          )}
        </div>
      </div>

      <div className="top-listing-header-filters top-listing-header-filters--pills">
        <div className="filter-options filters-desktop filter-options--pills">
          {filterOptions.map((option: any) => (
            <button
              key={option.value}
              className={`filter-option ${
                activeFilter === option.value ? "filter-option-active" : ""
              }`}
              onClick={() => setActiveFilter(option.value)}
            >
              {option.title} ({option.count})
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
